import { IFlags, IUser } from './user.interface'

export class User {
  id: string
  fullName: string
  initials: string
  avatar: string
  country: string
  flags: IFlags
  email: string
  dni: string
  lastName: string
  firstName: string
  constructor(from: IUser) {
    this.id = from._id
    this.fullName = from.fullName
    this.initials = from.initials
    this.avatar = from.avatar
    this.country = from.profile.country ? from.profile.country : 'es'
    this.flags = from.flags
    this.email = from.email
    this.dni = from.profile.dni
    this.lastName = from.profile.last_name
    this.firstName = from.profile.first_name
  }
}
